import styled from "styled-components"

const StyledStepper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 24px;
  align-self: flex-end;
`

const StepItem = styled.div<{ $isActive: boolean }>`
  width: 24px;
  height: 4px;
  border-radius: 1px;
  background: ${(props) =>
    props.$isActive
      ? "var(--Schemes-Primary-Container-Variant-2, #0FBDD4)"
      : "var(--White_20, rgba(255, 255, 255, 0.20))"};
`

const Stepper = ({ currentStep }: { currentStep: number }) => {
  return (
    <StyledStepper>
      {[0, 1, 2].map((step) => (
        <StepItem $isActive={currentStep >= step} key={step} />
      ))}
    </StyledStepper>
  )
}

export default Stepper
